<template>
  <div id="Atribuicao" class="small">
    <span>
      <div>
        <span class="badge badge-secondary badge-pill ">
          {{equipamento.tipo_equipamento.descricao}} 
        </span>
        {{equipamento.marca_modelo}}
      </div>
      <span class="text-muted" v-if="equipamento.imei1">
      IMEI: {{equipamento.imei1}}<span v-if ="equipamento.imei2">/{{equipamento.imei2}}</span>
      </span>
      <span class="text-muted" v-if="equipamento.num_serie">
      NS: {{equipamento.num_serie}}
      </span> 
      
    </span>
    <p class="alert alert-danger" v-if="errors.length">
      <span v-for="error in errors" v-bind:key="error">{{ error }}</span>
    </p>
    <div class="form-group">
      <label>Observações</label>
      <input type="text" v-model="observacao" class="form-control form-control">
    </div>
    <div class="modal-footer">
      <slot name="footer">
        <button class="btn btn-success" @click="confirmModal($event)">Ok</button>
        <button class="btn btn-cancel" type="cancel" @click="closeModal($event)">Cancelar</button>
      </slot>
    </div>
  </div>
</template>
<script>
const fb = require('../../config/db.js')

export default {
  name: 'Atribuicao',
  props: ["equipamentoId", "acao"],
  data(){
    return{
      observacao: '',
      errors: [],
      equipamento: {
        'tipo_equipamento' : { 'idtipo_equipamento' : "", 'descricao' : '' }, 
        'marca_modelo' : "", 
        'imei1' : "", 
        'imei2' : "", 
        'num_serie' : "",
        'num_nota' : "", 
        'data_nota' : "", 
        'valor' : "", 
        'fornecedor' : "", 
        'data_entrada' : '',  
        'pessoa_id' : '',  
      },
    }
  },
  created(){
    this.getEquipamento();
  },
  methods: {
    getEquipamento(){
      var equipamento = [];
      fb.Equipamento.doc(this.equipamentoId).onSnapshot(p => {
        equipamento = p.data();
        equipamento.id = p.id;
        this.equipamento = equipamento;
      });      
    },
    closeModal(){
      this.$emit('atribuicao-cancel');
    },
    confirmModal(){
      this.errors = [];
      if (this.observacao.trim() == '')
        this.errors.push('Observação é obrigatória!');
      
      if (this.errors.length)
        return;
        
      this.$emit('atribuicao-ok', this.observacao, this.acao);
    }
  }
 
}
</script>
